(() => {
if (customElements.get('dg-sticky-buy')) return;
customElements.define('dg-sticky-buy', class extends HTMLElement {
connectedCallback() {
this.abort = new AbortController();
const signal = this.abort.signal;
this.button = this.querySelector('button');
this.status = this.querySelector('[role="status"]');
this.update = () => {
const component = Array.from(document.querySelectorAll('product-form-component')).find(el => el.dataset.productId === this.dataset.productId && !el.closest('dialog, product-card, quick-add-component'));
this.original = component?.querySelector('button[ref="addToCartButton"]');
this.form = this.original?.form;
if (!this.original || !this.form) { this.hidden = true; return; }
const overlay = document.querySelector('dialog[open], [aria-modal="true"]:not([hidden])');
this.hidden = !matchMedia('(max-width:749px)').matches || this.original.getBoundingClientRect().bottom >= 0 || !!overlay;
this.button.disabled = !!this.pending || this.original.disabled;
const label = this.pending ? 'Wird hinzugefügt …' : (this.original.querySelector('.add-to-cart-text__content')?.textContent.trim() || 'In den Warenkorb');
if (this.button.textContent !== label) this.button.textContent = label;
};
this.schedule = () => {
if (this.frame) return;
this.frame = requestAnimationFrame(() => { this.frame = null; this.update(); });
};
window.addEventListener('scroll', this.schedule, {passive:true,signal});
window.addEventListener('resize', this.schedule, {passive:true,signal});
document.addEventListener('variant:update', this.schedule, {signal});
document.addEventListener('variant:selected', this.schedule, {signal});
this.observer = new MutationObserver(records => {
if (records.some(r => !this.contains(r.target))) this.schedule();
});
this.observer.observe(document.body, {subtree:true,childList:true,attributes:true,attributeFilter:['disabled','open','aria-modal','hidden']});
this.button.addEventListener('click', () => {
this.update();
if (this.button.disabled || !this.original) return;
if (!this.form.checkValidity()) {
this.form.scrollIntoView({block:'center',behavior:'auto'});
this.form.reportValidity(); return;
}
this.status.textContent = '';
this.pending = true; this.update();
this.original.click();
this.timer = setTimeout(() => {
this.pending = false;
this.status.textContent = 'Bitte prüfe den Warenkorb, bevor du erneut hinzufügst.';
this.update();
}, 15000);
}, {signal});
document.addEventListener('cart:update', event => {
if (!this.pending || String(event.detail?.data?.productId) !== this.dataset.productId) return;
clearTimeout(this.timer); this.pending = false;
this.status.textContent = event.detail?.data?.didError ? 'Bitte prüfe die gewünschte Menge im Warenkorb.' : 'Zum Warenkorb hinzugefügt.';
this.schedule();
}, {signal});
document.addEventListener('cart:error', event => {
if (!this.pending || event.detail?.sourceId !== this.form?.id) return;
clearTimeout(this.timer); this.pending = false;
this.status.textContent = event.detail?.data?.message || 'Hinzufügen fehlgeschlagen. Bitte erneut versuchen.';
this.schedule();
}, {signal});
this.update();
}
disconnectedCallback() {
this.abort?.abort(); this.observer?.disconnect();
clearTimeout(this.timer); cancelAnimationFrame(this.frame);
}
});
})();